import { StoreBodyBlock } from 'constants/enums';

import { TemplateStudioBuyOneGetManyForm } from 'components/TemplatesStudio/Components/FormPage/Sidebar/Main/BlocksForms/BuyOneGetMany';

import { MultiInstanceFormComponent } from './multiInstanceBlocks.types';

export const MULTI_INSTANCE_FORM_COMPONENT_BY_BLOCK: ReadonlyMap<
  StoreBodyBlock,
  MultiInstanceFormComponent
> = new Map([
  [StoreBodyBlock.onePlusMany, TemplateStudioBuyOneGetManyForm]
]);

export const getMultiInstanceFormComponent = (
  block: StoreBodyBlock
): MultiInstanceFormComponent | undefined =>
  MULTI_INSTANCE_FORM_COMPONENT_BY_BLOCK.get(block);
